module.exports = ".login-form {\n  background-color: #cccccc;\n  padding: 20px;\n  text-align: center; }\n  .login-form .btn {\n    display: block;\n    width: 100px;\n    margin: 15px auto; }\n  .login-form .link {\n    margin-top: 10px;\n    margin-bottom: 10px; }\n  .login-form .right {\n    text-align: right; }\n  .form-title {\n  text-align: center;\n  margin: 0 !important; }\n  .login-container {\n  margin: 0 auto;\n  max-width: 400px;\n  padding: 20px;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login-form/login-form.scss
// module id = ./src/app/components/login-form/login-form.scss
// module chunks = main